/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForAIAgentsTraceCollector extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForAIAgentsTraceCollector");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForAIAgentsTraceCollector.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForAIAgentsTraceCollector>): BackgroundJobPayloadForAIAgentsTraceCollector {
        let obj = Object.assign(new BackgroundJobPayloadForAIAgentsTraceCollector(), model);
        BackgroundJobPayloadForAIAgentsTraceCollector.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForAIAgentsTraceCollector>): BackgroundJobPayloadForAIAgentsTraceCollector {
        if (!model) return null;
        return BackgroundJobPayloadForAIAgentsTraceCollector.newInstance(<BackgroundJobPayloadForAIAgentsTraceCollector> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForAIAgentsTraceCollector) {
        if (!obj) return;

        models.BackgroundJobPayloadForAIAgentsTraceCollector.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForAIAgentsTraceCollector): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForAIAgentsTraceCollector.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * AWS service account ID whose aws/spans log group is scanned for agent spans
     */
    service_account_id: string;

}
